import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./api";

/**
 * App-wide TanStack Query client. Defaults tuned for a dashboard:
 *   - stale 30s so navigating back doesn't refetch instantly
 *   - retry only on network / 5xx; 401/403/404 are user errors
 *     and retrying just hides them
 *   - refetchOnWindowFocus stays true (default) — useful for sync data
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        if (error instanceof ApiError) {
          if (error.status >= 400 && error.status < 500) return false;
        }
        return failureCount < 2;
      }
    },
    mutations: {
      retry: false
    }
  }
});
